// Formato homologado del momento de guardado automático, usado por la barra
// de navegación del form IR y del panel de evaluación: "15 jul, 16:48".
export const formatSavedAt = (date: Date): string => {
  const day = date
    .toLocaleDateString('es-CL', { day: 'numeric', month: 'short' })
    .replace('.', '');
  const time = date.toLocaleTimeString('es-CL', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false, // 24h ("16:48"), no "4:48 p. m."
  });
  return `${day}, ${time}`;
};
